export default [
  {
    'text': 'NONE',
    'state': 'NONE'
  },
  {
    'text': '앱 업데이트',
    'state': 'APP_UPDATE'
  },
  {
    'text': '앱 메뉴 이동 (불가)',
    'state': 'MOVE_NATIVE'
  },
  {
    'text': '웹뷰',
    'state': 'WEBVIEW'
  },
  {
    'text': '이미지 팝업',
    'state': 'IMAGE_POPUP'
  },
  {
    'text': '외부 브라우저 연결',
    'state': 'BROWSER'
  }
];



// WEBPACK FOOTER //
// ./src/api/pushMessageAction.js